import { ListPageLayout } from "../../components";
import { usuariosApi } from "../../services";

export default function Usuarios() {
  return (
    <ListPageLayout
      title="Usuários"
      creation={{ url: "/usuarios/cadastro" }}
      edition={{ url: "/usuarios/cadastro" }}
      deletion={{ handler: (id) => usuariosApi.destroy(id) }}
      table={{
        loader: usuariosApi.all,
        columns: [
          { title: "Id", field: "id" },
          { title: "Nome", field: "nome" },
          { title: "E-mail", field: "email" },
          { title: "Telefone", field: "telefone", columnType: "phone" },
          { title: "Ativo", field: "status", columnType: "YesOrNo" },
        ],
      }}
    />
  );
}
